import api from '../utils/api';

export const getAllCompanyShopMonitorIPs = (config = {}) => {
    const { data, options } = config;
    return api({
        url: '/api/company-shop-monitor-ips/getAll',
        method: "POST",
        data: data,
        ...options,
    });
};

export const AddUpdateShopMonitorIPs = (contest) => {
    let url = '/api/company-shop-monitor-ips/addUpdate';
    return api({
        url: url,
        method: 'POST',
        data: contest
    })
}

export const deleteCompanyShopMonitorIPs = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `/api/company-shop-monitor-ips/delete/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}

export const checkValidIpAddress = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `/api/company-shop-monitor-ips/valid-ip-address/${data}`,
        method: 'GET',
        data,
        ...options
    })
}